import { Module, Mutation } from 'vuex-module-decorators'
import { footerType } from '@/types/footer.type'
import BaseStore from '@/store/BaseStore'

@Module({
  name: 'PageStore',
  namespaced: true,
  stateFactory: true
})
export default class PageStore extends BaseStore {
  private _title: string = ''

  leftFooterActions: footerType.IAction[] = []

  rightFooterActions: footerType.IAction[] = []

  _titleColor: string = '#7b92d7'

  get title(): string {
    return this._title
  }

  get titleColor(): string {
    return this._titleColor
  }

  @Mutation
  public setTitle(title: string) {
    this._title = title
  }

  @Mutation
  public setLeftFooterActions(actions: footerType.IAction[]) {
    this.leftFooterActions = actions
  }

  @Mutation
  public setRightFooterActions(actions: footerType.IAction[]) {
    this.rightFooterActions = actions
  }

  @Mutation
  public setTitleColor(color: string) {
    console.log(color)
    this._titleColor = color
  }

  @Mutation
  public initializeTitleColor() {
    this._titleColor = '#7b92d7'
  }
}
